import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getOrderDetails, getDataName } from '../../dashboard/reducer';
import { getTokenId, getJWT } from '../../../redux/reducers/authenticationReducers';
import { selectCategory, selectSubcategory, loading } from '../actions';
import { browserHistory } from 'react-router';

import RightNavigationContainer from './RightNavigationContainer';
import Settings from './Settings';
import MenuList from './MenuList';

class RightNavigation extends React.Component {
  initialState(props) {
    return {
      show: false,
      activeTab: props.menu !== false && props.page === 'dashboard' ? 1 : 2,
    };
  }

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.isActiveTab = this.isActiveTab.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.state = this.initialState(props);
  }

  onSelect(data, categoryId) {
    const { orderDetails, token, jwt, dataname } = this.props;
    this.props.actions.loading(true);
    this.props.actions.selectCategory(categoryId, false);
    this.setState({
      show: false,
    });
    this.props.actions
      .selectSubcategory(
        data.id,
        data.text,
        orderDetails.modeOfOrder,
        token,
        jwt,
        dataname
      )
      .then(() => {
        return this.props.actions.loading(false);
      });
    browserHistory.push(this.props.link);
  }

  toggle() {
    this.setState({
      show: !this.state.show,
    });
  }

  isActiveTab(tabId) {
    return this.state.activeTab === tabId ? 'active-tab' : '';
  }

  handleTabClick(tabId) {
    this.setState({
      activeTab: tabId,
    });
  }

  render() {
    return (
      <div className="right-navigation">
        <div
          className={`col-md-2 col-xs-2 col-sm-2 text-right side-menu-icon ${
            this.props.menu !== false
              ? 'side-menu-icon'
              : 'side-user-menu-icon'
          }`}
        >
          <i
            onClick={this.toggle}
            className={`fa fa-${
              this.props.menu !== false ? 'bars' : 'user'
            } cursorPointer olo-client-theme-color`}
          />
        </div>
        <RightNavigationContainer
          toggle={() => this.toggle()}
          show={this.state.show}
          auth={this.props.auth}
        >
          <div className="tab-menus">
            {this.props.menu !== false ? (
              <div
                onClick={() => this.handleTabClick(1)}
                className={`tab-item ${this.isActiveTab(1)}`}
              >
                Menu
              </div>
            ) : null}

            <div
              onClick={() => this.handleTabClick(2)}
              className={`tab-item ${this.isActiveTab(2)}`}
              style={{
                width: this.props.menu !== false ? '50%' : '100%',
                textAlign: this.props.menu !== false ? 'center' : 'left',
              }}
            >
              User Account
            </div>
          </div>

          {this.isActiveTab(1) ? (
            <MenuList
              activeCategory={this.props.restaurantMenu.mainMenuItemClicked}
              activeSubCategory={this.props.restaurantMenu.subMenuItemClicked}
              restaurantMenu={this.props.restaurantMenu.menuCategories}
              onSelect={(data, categoryId) => this.onSelect(data, categoryId)}
              page={this.props.page}
            />
          ) : null}

          {this.isActiveTab(2) ? (
            <Settings
              signIn={this.props.signIn}
              signOut={this.props.signOut}
              auth={this.props.auth}
              link={this.props.link}
              toggle={this.toggle}
              page={this.props.page}
            />
          ) : null}
        </RightNavigationContainer>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  restaurantMenu: state.menuCategories,
  orderDetails: getOrderDetails(state),
  token: getTokenId(state),
  jwt: getJWT(state),
  dataname: getDataName(state),
  auth: state.auth,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    { selectSubcategory, loading, selectCategory },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(RightNavigation);



// WEBPACK FOOTER //
// ./src/views/menu/components/RightNavigation.jsx